import React, {useCallback, useEffect, useMemo, useState} from 'react';
import _ from 'lodash';
import {forceRefreshSessionInfo} from 'module/SessionInfo/api/SessionInfoAPI';
import {switchMandantHandler} from 'module/SessionInfo/api/SwitchMandantAPI';
import {MandantTO} from 'generated/JavaTO'
import {Slct} from 'module/Slct/component/Slct'
import {SlctOption} from 'module/Slct/type/SlctType'
import {SetCb} from 'type/SetCb'
import {filterOptionsSlct} from 'module/Slct/util/filterOptionsSlct'

interface MandantEnriched extends MandantTO {
	isDefault?: boolean
}

function mapMandantToSlctOption(mandant: MandantEnriched): SlctOption<MandantEnriched, string> {
	let label = mandant.text || ''

	if (mandant.isDefault) {
		if (mandant.text) label += ' '
		label += "(Default)";
	}
	return {
		value: mandant.id,
		label,
		model: mandant,
	}
}

interface Props {
	mandant: MandantTO | null
	defaultMandant: MandantTO | null
	alternativeMandants: MandantTO[]
}

export const MandantSelect = ({mandant: savedMandant, defaultMandant, alternativeMandants = []}: Props) => {
	const [mandant, setMandant] = useState<MandantEnriched | null>(savedMandant);
	const defaultMandantId = defaultMandant && defaultMandant.id || null;
	//override saved and current mandant id with null when equal to default mandant id (null represents default)
	let savedMandantId = savedMandant && savedMandant.id || null;
	if (savedMandantId === defaultMandantId) savedMandantId = null;
	let mandantId = mandant && mandant.id || null;
	if (mandantId === defaultMandantId) mandantId = null;
	const ds = useMemo(() => [
		...alternativeMandants,
		{
			...defaultMandant,
			isDefault: true,
		} as MandantEnriched,
	].map(mapMandantToSlctOption), [alternativeMandants, defaultMandant])

	useEffect(() => {
		const t = setTimeout(() => {
			if (!_.isEqual(mandantId, savedMandantId)) {
				switchMandantHandler(mandantId).then(() => forceRefreshSessionInfo())
			}
		}, 1500);
		return () => clearTimeout(t);
	}, [savedMandantId, mandantId]);

	const onChange: SetCb<SlctOption<MandantEnriched, string> | null> = useCallback((value) => setMandant(value?.model || null), [])

	return (
		<Slct
			value={mandant?.id}
			options={ds}
			onChange={onChange}
			showClearButton
			disabled={ds.length < 2}
			filterOptions={filterOptionsSlct}
		/>
	);
};